import { render, staticRenderFns } from "./AssignmentsEntry.vue?vue&type=template&id=21f6d777&"
import script from "./AssignmentsEntry.vue?vue&type=script&lang=js&"
export * from "./AssignmentsEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports